import React from 'react';
import { Box, Typography } from '@mui/material';

const card = {
    background: 'linear-gradient(180deg, rgba(0,120,255,0.12) 0%, rgba(1,1,52,0.4) 100%)',
    border: '1px solid rgba(0,215,255,0.28)',
    borderRadius: '22px',
    p: 2.5,
};

const statGrid = {
    display: 'grid',
    gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
    gap: 2,
};

function Stat({ label, value, hint }) {
    return (
        <Box>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.6px', color: 'var(--ecal-lightgrey)', mb: 0.5 }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: 'var(--ecal-white)', lineHeight: 1.2 }}>
                {value || '—'}
            </Typography>
            {hint && <Typography sx={{ fontSize: '11px', color: 'var(--ecal-midgrey)', mt: 0.25 }}>{hint}</Typography>}
        </Box>
    );
}

function Engagements({ score = 0, total = 1000, pct = 0, rankingPublisher, rankingCountry, rankingCountryName, rankingWorld }) {
    return (
        <Box sx={card}>
            <Typography sx={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '2.16px', color: 'var(--ecal-lightblue)', mb: 2 }}>
                Engagement
            </Typography>
            <Box sx={statGrid}>
                <Stat label="Engagement score" value={`${score}/${total}`} />
                <Stat label="Rank in #1 publisher" value={rankingPublisher} hint="vs other subscribers" />
                <Stat label="Rank in country" value={rankingCountry} hint={rankingCountryName} />
                <Stat label="Rank worldwide" value={rankingWorld} hint="all ECAL subscribers" />
            </Box>
            <Box sx={{ height: 8, borderRadius: '999px', background: 'rgba(255,255,255,0.05)', overflow: 'hidden', mt: 2.5 }}>
                <Box sx={{ height: '100%', width: `${pct}%`, background: 'linear-gradient(90deg, #FFDF10, #FF9E00, #FF4D00)', borderRadius: '999px', transition: 'width 0.6s ease' }} />
            </Box>
            <Typography sx={{ fontSize: '12px', color: 'var(--ecal-lightgrey)', mt: 1 }}>
                Your engagement grows with every event added, opened or clicked.
            </Typography>
        </Box>
    );
}

export default Engagements;
